import React, { useState } from "react";
import { Shell, Header } from "./Shell";
import { s } from "../lib/theme";
import { Auth, errMsg } from "../lib/api";

export default function ChangePassword({ user, forced, onSaved, onCancel }) {
  const [cur, setCur] = useState("");
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function save() {
    if (p1.length < 6) { setErr("Password must be at least 6 characters."); return; }
    if (p1 !== p2) { setErr("The two new entries don't match."); return; }
    if (!forced && !cur) { setErr("Enter your current password."); return; }
    setBusy(true);
    setErr("");
    try {
      const me = await Auth.changePassword({
        current_password: forced ? null : cur,
        new_password: p1,
      });
      onSaved(me);
    } catch (e) {
      setErr(errMsg(e, "Could not change password."));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Shell
      header={
        <Header
          title={forced ? "Set Your Password" : "Change Your Password"}
          sub={forced ? "For security, replace the starter password with your own." : "Choose a new private password."}
        />
      }
    >
      <div style={{ maxWidth: 400 }}>
        <div style={{ ...s.info, marginBottom: 14 }}>
          Signed in as <strong>{user.name}</strong> ({user.email}).
        </div>
        {!forced && (
          <>
            <label style={s.label}>Current password</label>
            <input data-testid="cp-current-input" style={s.input} type="password" value={cur} onChange={(e) => setCur(e.target.value)} />
          </>
        )}
        <label style={s.label}>New password (6+ characters)</label>
        <input data-testid="cp-new-input" style={s.input} type="password" value={p1} onChange={(e) => setP1(e.target.value)} />
        <label style={s.label}>Confirm new password</label>
        <input
          data-testid="cp-confirm-input"
          style={s.input}
          type="password"
          value={p2}
          onChange={(e) => setP2(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && save()}
        />
        {err && <div data-testid="cp-error" style={s.error}>{err}</div>}
        <button data-testid="cp-save-btn" disabled={busy} style={s.btnPrimary} onClick={save}>
          {busy ? "Saving…" : "Save Password"}
        </button>
        {!forced && (
          <button data-testid="cp-cancel-btn" style={{ ...s.btnGhost, width: "100%", marginTop: 8 }} onClick={onCancel}>
            Cancel
          </button>
        )}
        {forced && (
          <div style={{ ...s.muted, marginTop: 14, fontSize: 12, lineHeight: 1.5 }}>
            You must set your own password before continuing. Keep it private and do not share it.
          </div>
        )}
      </div>
    </Shell>
  );
}
